// Feb 2026 · 10 Feb 2026 · TEMPORÄRER PIN-BYPASS.
//
// STATUS (Deployment 11 Sep 2026): **DEAKTIVIERT** — der Bypass wurde
// nach dem Deployment wieder ausgeschaltet, die 4-stellige PIN gilt
// wieder für alle Admin-Änderungen (Projekte, Rechnungen, Kunden-Profile,
// Concierge-Impersonation).
//
// Wenn dieses Flag `true` ist, überspringen die Admin-PIN-Dialoge
// (`AdminPinPromptDialog`, `PinUnlockDialog`) den 4-stelligen PIN-
// Prompt vollständig UND rufen `onSuccess()` (bzw. `unlockOtherConcierge()`)
// direkt beim Öffnen auf. Kein Backend-Verify-Call, keine Modal-UI, keine
// PIN-Audit-Log-Zeile — reine Frontend-Umgehung.
//
// Der Customer-PIN-Prompt (`CustomerPinPromptDialog` — digitale Signatur
// für Kunden-Angebotsentscheidungen) ist bewusst NICHT betroffen: er ist
// Vertragssignatur, keine Team-Bequemlichkeit.
//
// **REAKTIVIERUNG BEI BEDARF**:
//   1. Wert auf `true` setzen.
//   2. Frontend hot-reload greift automatisch — kein Cache-Bust nötig.
export const PIN_BYPASS_ENABLED = false;
